
$(document).ready(function () {
    /**
     * Drop down
     */
    var $dropDown = $('.drop_down');
    if ($dropDown.length) {
        let $this;
        $('body').on('click', '.drop_down .drop_down-list li', function (e) {
            $this = $(this);
            // if ($(this).hasClass('active')) return false;

            if (!$(this).hasClass('reading')) {
                var selectedText = $(this).text();

                var selectedValue = $(this).attr('data-value');
                selectedValue = selectedValue || selectedText;
                if(!$('.icon-close').is(e.target)) {
                    $(this).closest('.drop_down').find('.select').addClass('text-added');
                    if($(this).closest('.drop_down').hasClass('multi-list')) {
                        $(this).closest('.drop_down_search').find('.select>span').html($(this).find('p').text());
                    } else {
                        $(this).closest('.drop_down').find('.select>span').html(selectedText);
                    }
                    $(this).parent().find('li').removeClass('active');
                    $(this).addClass('active');

                    if ($(this).closest('.drop_down').find('>input[type=hidden]')) {
                        $(this).closest('.drop_down').find('>input[type=hidden]').val(selectedValue);
                    }
                    if ($(this).closest('.drop_down').find('>label.error')) {
                        $(this).closest('.drop_down').find('>label.error').remove();
                    }
                    if (selectedValue) {
                        $(this).trigger('dropdown-change', [selectedValue]);
                    }

                    // if($(this).closest('.drop_down').hasClass('country-select')) {
                    //     $('.region-select').removeClass('disabled');
                    // }

                    if ($(this).closest('.drop_down').hasClass('click_open')) {
                        $(this).closest('.drop_down').removeClass('open');
                    }

                    if ($dropDown.find('.search_box').length) {
                        $dropDown.find('.search_box').val('');
                        $dropDown.find('li:not(.empty)').removeAttr('style');
                        $dropDown.find('.list-title').removeAttr('style');
                    }

                    if($this.closest('.filter_row').length) {
                        if($this.closest('.filter_row').siblings('.selected_filter_list').find('li.country-item').length) {
                            $this.closest('.filter_row').siblings('.selected_filter_list').find('li.country-item').remove();
                        }
                        $this.closest('.filter_row').siblings('.selected_filter_list').find('ul').append('<li data-id="' + $this.attr('id') + '" class="country-item">' + $this.text() + ' <i class="icon-close s-8"></i></li>')
                    }
                }
            }

            $('body').on('click', '#deleteFilter .confirm-btn', function() {
                if($this.closest('.drop_down').find('.select span').text() == $this.text()) {
                    $this.closest('.drop_down').find('.select').removeClass('text-added');
                    $this.closest('.drop_down').find('.select span').text('');
                }
                $this.remove();
                $(this).closest('.wrap_popup').find('.close').trigger('click');
            });
        });

        //For open after click
        var $headerDropDown = $('.drop_down.click_open, .drop_down_search.click_open');
        $headerDropDown.find(' > .select').on('click', function () {
            if ($(this).parent().hasClass('disabled')) return false;

            $headerDropDown.find(' > .select').not($(this)).parent().removeClass('open');
            $(this).parent().toggleClass('open');
            if($(this).parent().hasClass('js-filter-regions') && !$(this).parent().hasClass('open')){
                $(this).parent().addClass('regions-closed');
            }
            if($(this).parent().hasClass('js-site-regions') && !$(this).parent().hasClass('open')){
                $(this).parent().addClass('regions-closed');
            }

            //Set focus if this block has search area
            if ($(this).closest('.drop_down ').hasClass('drop_down_search')) {
                $(this).closest('.drop_down ').find('input.search_box').focus();
            }
        });

        $(document).on('mouseup', function (e) {
            var container = $(".drop_down");
            if (container.has(e.target).length === 0 && container.hasClass('open')) {
                container.removeClass('open');

                $('.content-col--left').removeClass('drop_down_open');
            }
        });
    }

    /**
     * Drop down search
     */
    var $dropDownSearch = $('.drop_down_search');
    if ($dropDownSearch.length) {
        $dropDownSearch.on('keyup', '.search_box', function () {
            var val = $(this).val().toLowerCase(),
                $searchThisUl = $(this).closest('.drop_down_search').find('.drop_down-list ul'),
                found = 0;
                if($(this).closest('.drop_down_search').hasClass('selectholder')) {
                    var $searchThisLi = $(this).closest('.drop_down_search').find('.drop_down-list ul li label');
                } else {
                    var $searchThisLi = $(this).closest('.drop_down_search').find('.drop_down-list ul li');
                }

            $searchThisUl.each(function () {
                $searchThisLi.each(function () {
                    if (!$(this).hasClass('empty')) {
                        if ($(this).text().toLowerCase().indexOf(val) === -1) {
                            if($(this).closest('.drop_down_search').hasClass('selectholder')) {
                                $(this).closest('li').css('display', 'none');
                                $(this).closest('li').addClass('hidden');
                            } else {
                                $(this).css('display', 'none');
                                $(this).addClass('hidden');
                            }
                        } else {
                            if($(this).closest('.drop_down_search').hasClass('selectholder')) {
                                $(this).closest('li').removeAttr('style');
                                $(this).closest('li').removeClass('hidden');
                            } else {
                                $(this).removeAttr('style');
                                $(this).removeClass('hidden');
                            }
                            found++;
                        }
                    }
                });

                if ($(this).find('.hidden').length === $(this).find('li').length && val.length > 0) {
                    $(this).prev('.list-title').css('display', 'none');
                } else {
                    $(this).prev('.list-title').removeAttr('style');
                }
            });

            if (found <= 0 && val.length > 0) {
                $(this).closest('.drop_down_search').find('.drop_down-list p.empty').removeAttr('style').show();
            } else {
                $(this).closest('.drop_down_search').find('.drop_down-list p.empty').css('display', 'none');
            }
        });

        $(document).on('mouseup', function (e) {
            $(".drop_down_search").each(function(){
                var container = $(this);
                if (container.has(e.target).length === 0 && container.hasClass('open')) {
                    container.removeClass('open');
                    if(container.hasClass('js-filter-regions') || container.hasClass('js-site-regions')){
                        container.addClass('regions-closed');
                    }
                }
            });
        });
    }
});
